.componentWebsiteBlackUnionLine {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;


  &.green {
    .line {
      background: var(--web-green);
    }

    .blur {
      background: var(--web-green);
    }
  }

  &.white {
    .line {
      background: var(--white);
    }

    .blur {
      background: var(--white);
    }
  }

  .line {
    height: 1px;
    width: 100%;
    background: var(--web-blue-light);
    opacity: 0.5
  }

  .blur {
    background: var(--web-blue-light);
    width: 100%;
    position: absolute;
    pointer-events: none;
    filter: blur(50px);
    height: 19px;
  }
}